skrilla.controller('selectFranchiseModalCtrl', function ($scope, $mdDialog, cacheService, modalService) {
    $scope.sport = cacheService.getObjectOrElse("sport", function(){
        console.log("No sport found, closing")
        modalService.dismissAll()
    });

    $scope.select = function(franchise){
        $mdDialog.hide(franchise)
    }
});

